import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  signal,
  input,
  output,
  effect,
  inject,
  Injector,
} from '@angular/core';
import { Router } from '@angular/router';
//import { fromEvent } from 'rxjs';
//import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { Location } from '../../models/classes/location';
import { OTObject } from '../../models/classes/object';
import { AssetsService } from '../../services/asset.service';
import { I18nService } from '../../services/i18n.service';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { FilterComponent } from '../filter/filter';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { sanitizeUnicodeText } from '../../utilities/global.util';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { App_Routes } from '../../enums/router.enum';

export class ObjectFilter {
  searchTerm = '';
  filterList(list: OTObject[]): OTObject[] | Location[] {
    return list.filter((item) =>
      item.objectName.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }
}

@Component({
  selector: 'app-search-filter',
  imports: [NzModalModule, NzSelectModule, NzBadgeModule, NzIconModule, FilterComponent],
  templateUrl: './search-filter.html',
  styleUrls: ['./search-filter.scss'],
  animations: [
    trigger('expandCollapse', [
      state('expanded', style({ width: '100%' })),
      state('collapsed', style({ width: 'auto' })),
      transition('collapsed => expanded', [animate('500ms cubic-bezier(0.15, 0, 0.25, 1)')]),
      transition('expanded => collapsed', [animate('250ms cubic-bezier(0.15, 0, 0.25, 1)')]),
    ]),
  ],
})
export class SearchFilterComponent implements AfterViewInit {
  filter = input(new ObjectFilter());
  sidebar = input(false);
  onlysearch = input(false);
  plantsFilter = input(false);
  notificationsFilter = input(false);
  plantFilterStatus = input<any>(null);
  countryOrRegionSelected = input<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  filterClick = output<void>();
  searchFilterChanged = output<void>();

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  collapsed = signal(true);
  filterCount = signal(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  filter_open = signal(false);

  private router = inject(Router);
  public i18n = inject(I18nService);
  public assetsService = inject(AssetsService);
  private injector = inject(Injector);

  constructor() {
    effect(
      () => {
        this.assetsService.getPlants();
        this.filterCount.set(this.assetsService.FilterSettingsCount);
      },
      { injector: this.injector }
    );
  }

  onChangeFilter() {
    this.searchFilterChanged.emit();
  }

  checkUpdates() {
    // Placeholder for future implementation.
  }

  openFilter() {
    this.filter_open.set(true);
  }

  closeFilter() {
    this.filter_open.set(false);
  }

  ngAfterViewInit() {
    if (this.sidebar()) {
      // const searchTerm$ = fromEvent<InputEvent>(this.searchInput.nativeElement, 'input').pipe(
      //   debounceTime(500),
      //   distinctUntilChanged(),
      //   map((event) => (event.target as HTMLInputElement).value)
      // );
    }

    this.searchInput.nativeElement.value = this.assetsService.getSearchTerm();
  }

  onClick() {
    this.filterClick.emit();
    setTimeout(() => this.router.navigate([App_Routes.FILTER]));
  }

  expand() {
    this.collapsed.set(false);
    this.searchInput.nativeElement.value = this.assetsService.getSearchTerm();
    setTimeout(() => this.searchInput.nativeElement.focus());
  }

  collapse() {
    this.collapsed.set(true);
  }

  search() {
    this.collapsed.set(true);
    this.assetsService.updateSearchTerm(this.searchInput.nativeElement.value);
  }

  clearSearchTerm() {
    this.searchInput.nativeElement.value = GLOBAL_CONSTANT.EMPTY_STRING;
    this.search();
    this.searchFilterChanged.emit();
  }

  clearFilter(event: Event) {
    this.assetsService.clearFilter();
    this.searchFilterChanged.emit();
    event.stopPropagation();
  }

  onTextInput(event: Event): void {
    const inputEl = event.target as HTMLInputElement;
    const cleaned = sanitizeUnicodeText(inputEl.value);
    if (cleaned !== inputEl.value) {
      inputEl.value = cleaned; // update the DOM value
    }
    this.searchFilterChanged.emit();
  }
}
